export const BOT_NAMES = [
  // Рим
  'Сципион',
  'Цезарь',
  'Август',
  'Антоний',
  'Помпей',
  'Красс',
  'Марий',
  'Сулла',
  'Траян',
  'Адриан',
  'Аврелий',
  'Константин',
  'Велизарий',
  'Германик',
  'Тиберий',
  'Веспасиан',
  'Домициан',
  'Север',
  'Диоклетиан',
  'Брут',
  'Цицерон',
  'Катон',
  'Сенека',
  'Плиний',
  'Ливий',
  'Тацит',
  'Овидий',
  'Гораций',
  'Вергилий',
  'Катулл',

  // Карфаген
  'Ганнибал',
  'Гамилькар',
  'Гасдрубал',
  'Маго',
  'Ганнон',

  // Египет
  'Рамсес',
  'Тутмос',
  'Аменхотеп',
  'Эхнатон',
  'Тутанхамон',
  'Сети',
  'Ахмос',
  'Птолемей',
  'Клеопатра',
  'Хатшепсут',
  'Хеопс',
  'Хефрен',
  'Нармер',
  'Снофру',
  'Хасехем',

  // Древняя Персия
  'Кир',
  'Дарий',
  'Ксеркс',
  'Артаксеркс',
  'Камбиз',
  'Митридат',
  'Шапур',
  'Арташир',
  'Бахрам',
  'Ахемен',

  // Древняя Греция и Македония
  'Александр',
  'Леонид',
  'Перикл',
  'Фемистокл',
  'Аристид',
  'Павсаний',
  'Эпаминонд',
  'Пирр',
  'Ахиллес',
  'Одиссей',
  'Агамемнон',
  'Менелай',
  'Аякс',
  'Диомед',
  'Нестор',
  'Гектор',
  'Приам',
  'Тесей',
  'Геракл',
  'Персей',
  'Филипп',
  'Антипатр',
  'Кратер',
  'Селевк',
  'Антигон',
  'Кассандр',
  'Лисимах',
  'Деметрий',

  // Спарта
  'Ликург',
  'Клеомен',
  'Агис',
  'Брасид',
  'Агесилай',

  // Афины
  'Солон',
  'Мильтиад',
  'Алкивиад',

  // Месопотамия
  'Саргон',
  'Хаммурапи',
];
